import SvgIcon from './SvgIcon';
import SvgIconContext, { SvgIconProvider } from './SvgIconContext';

export { SvgIconContext, SvgIconProvider, SvgIcon };
